import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

export interface Grade {
  value: number;
  label: string;
}

export interface CountryGradeGroup {
  label: string;
  grades: Grade[];
}

export interface CountryGradeConfig {
  groups: CountryGradeGroup[];
}

export interface CountryFeatures {
  hasStandards: boolean;
  hasStateField: boolean;
}

export interface Tier2Subject {
  id: string;
  name: string;
  applicableGrades: number[];
}

export interface Tier1Subject {
  id: string;
  category: string;
  subjects: Tier2Subject[];
}

export interface EducationMetadata {
  country: string;
  gradeConfig: CountryGradeConfig;
  tier1Subjects: Tier1Subject[];
  features: CountryFeatures;
}

export interface SupportedCountry {
  code: string;
  name: string;
  flag: string;
}

export const SUPPORTED_COUNTRIES: SupportedCountry[] = [
  { code: 'US', name: _('common.countries.US'), flag: '🇺🇸' },
  { code: 'DE', name: _('common.countries.DE'), flag: '🇩🇪' },
  { code: 'PT', name: _('common.countries.PT'), flag: '🇵🇹' },
  { code: 'BR', name: _('common.countries.BR'), flag: '🇧🇷' },
  { code: 'UA', name: _('common.countries.UA'), flag: '🇺🇦' },
  { code: 'KR', name: _('common.countries.KR'), flag: '🇰🇷' },
];

export const SUPPORTED_COUNTRY_CODES = SUPPORTED_COUNTRIES.map((c) => c.code);
export const DEFAULT_COUNTRY_CODE = 'US';

const STANDARDS_COUNTRIES = new Set(['US']);

export function countryHasStandards(code: string): boolean {
  return STANDARDS_COUNTRIES.has(code);
}

export interface UsState {
  code: string;
  name: string;
}

export const US_STATES: UsState[] = [
  { code: 'AL', name: _('common.usStates.AL') },
  { code: 'AK', name: _('common.usStates.AK') },
  { code: 'AZ', name: _('common.usStates.AZ') },
  { code: 'AR', name: _('common.usStates.AR') },
  { code: 'CA', name: _('common.usStates.CA') },
  { code: 'CO', name: _('common.usStates.CO') },
  { code: 'CT', name: _('common.usStates.CT') },
  { code: 'DE', name: _('common.usStates.DE') },
  { code: 'FL', name: _('common.usStates.FL') },
  { code: 'GA', name: _('common.usStates.GA') },
  { code: 'HI', name: _('common.usStates.HI') },
  { code: 'ID', name: _('common.usStates.ID') },
  { code: 'IL', name: _('common.usStates.IL') },
  { code: 'IN', name: _('common.usStates.IN') },
  { code: 'IA', name: _('common.usStates.IA') },
  { code: 'KS', name: _('common.usStates.KS') },
  { code: 'KY', name: _('common.usStates.KY') },
  { code: 'LA', name: _('common.usStates.LA') },
  { code: 'ME', name: _('common.usStates.ME') },
  { code: 'MD', name: _('common.usStates.MD') },
  { code: 'MA', name: _('common.usStates.MA') },
  { code: 'MI', name: _('common.usStates.MI') },
  { code: 'MN', name: _('common.usStates.MN') },
  { code: 'MS', name: _('common.usStates.MS') },
  { code: 'MO', name: _('common.usStates.MO') },
  { code: 'MT', name: _('common.usStates.MT') },
  { code: 'NE', name: _('common.usStates.NE') },
  { code: 'NV', name: _('common.usStates.NV') },
  { code: 'NH', name: _('common.usStates.NH') },
  { code: 'NJ', name: _('common.usStates.NJ') },
  { code: 'NM', name: _('common.usStates.NM') },
  { code: 'NY', name: _('common.usStates.NY') },
  { code: 'NC', name: _('common.usStates.NC') },
  { code: 'ND', name: _('common.usStates.ND') },
  { code: 'OH', name: _('common.usStates.OH') },
  { code: 'OK', name: _('common.usStates.OK') },
  { code: 'OR', name: _('common.usStates.OR') },
  { code: 'PA', name: _('common.usStates.PA') },
  { code: 'RI', name: _('common.usStates.RI') },
  { code: 'SC', name: _('common.usStates.SC') },
  { code: 'SD', name: _('common.usStates.SD') },
  { code: 'TN', name: _('common.usStates.TN') },
  { code: 'TX', name: _('common.usStates.TX') },
  { code: 'UT', name: _('common.usStates.UT') },
  { code: 'VT', name: _('common.usStates.VT') },
  { code: 'VA', name: _('common.usStates.VA') },
  { code: 'WA', name: _('common.usStates.WA') },
  { code: 'WV', name: _('common.usStates.WV') },
  { code: 'WI', name: _('common.usStates.WI') },
  { code: 'WY', name: _('common.usStates.WY') },
  { code: 'DC', name: _('common.usStates.DC') },
];
